export function capitalizeFirstLetter(string?: string): string | undefined {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : undefined;
}

export function removeSpecialCharacters(string: string): string {
    return string.replace(/[^a-zA-Z0-9 ]/g, "");
}
